<template>
  <v-select label="Tipo de Grano"
    v-model="selected"
    :item-title="getGrainTypeDetail"
    :items="getGrainTypes" return-object
    :rules="[rules.requiredFieldRule]"
    variant="outlined"
    density="comfortable">
    <template #selection="{ item }">
      {{ getGrainTypeDetail(getRawItem(item)) }}
    </template>
    <template #item="{ item, props }">
      <v-list-item
        v-bind="props"
        :title="getGrainTypeDetail(getRawItem(item))"
      />
    </template>
  </v-select>
</template>

<script>
import { mapGetters } from 'vuex'
import TypesUtils from '../../services/types/TypesUtilFunctions'

export default {
  name: 'GrainTypeSelector',

  props: {
    modelValue: Object
  },

  data: () => ({
    rules: {
      requiredFieldRule: v => ((v !== null) && (typeof v !== 'undefined') && (v !== '') && (v.id > 0)) || 'Campo requerido.'
    }
  }),

  computed: {
    ...mapGetters('typesModule', ['getGrainTypes']),
    selected: {
      get () { return this.modelValue },
      set (v) {
        this.$emit('update:modelValue', v)
      }
    }
  },

  created () {
    this.$store.dispatch('typesModule/getGrainTypes')
    this.typesUtils = TypesUtils
  },

  methods: {
    getGrainTypeDetail (item) {
      return item ? this.typesUtils.getGrainTypeLegend(item) : ''
    },

    getRawItem (item) {
      return item ? (item.raw || item) : null
    }
  }
}
</script>
